import en from './en.js';
import zh from './zh.js';

function setLocale(i18n) {
  i18n.addResources('en', 'reactUI', en);
  i18n.addResources('zh', 'reactUI', zh);
}

export { setLocale };
